import React from "react";
import type { OverlapResolutionCallout } from "./overlapResolutionCalloutUtils";

type Props = {
  callouts: OverlapResolutionCallout[];
};

const OverlapResolutionCalloutList: React.FC<Props> = ({ callouts }) => {
  if (!callouts.length) {
    return null;
  }

  return (
    <ul className="overlap-resolution-callouts">
      {callouts.map((callout) => (
        <li
          key={callout.id}
          className={`overlap-resolution-callouts__item overlap-resolution-callouts__item--${callout.tone}`}
        >
          {callout.text}
        </li>
      ))}
    </ul>
  );
};

export default OverlapResolutionCalloutList;
